const values = [
  {
    icon: 'ri-heart-2-line',
    title: 'Atención Personalizada',
    desc: 'Cada paciente es único. Diseñamos planes de tratamiento adaptados a tus necesidades y objetivos específicos.',
  },
  {
    icon: 'ri-medal-line',
    title: 'Alta Calidad',
    desc: 'Utilizamos materiales de primera calidad y seguimos los más altos estándares odontológicos de la industria.',
  },
  {
    icon: 'ri-microscope-line',
    title: 'Tecnología Moderna',
    desc: 'Equipados con tecnología de punta para diagnósticos precisos y tratamientos más cómodos y efectivos.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16 scroll-animate">
          <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
            ¿Quiénes somos?
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#0A2540] mb-5">
            Sobre{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#0A2540] bg-clip-text text-transparent">
              MF Dental
            </span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto font-light">
            Un consultorio odontológico privado donde tu comodidad y salud bucal son nuestra prioridad.
          </p>
        </div>

        {/* Main content grid */}
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image side */}
          <div className="relative scroll-animate-left">
            <div className="relative rounded-3xl overflow-hidden" style={{ height: '520px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=friendly%20professional%20dentist%20in%20white%20coat%20smiling%20warmly%20at%20camera%20modern%20clean%20dental%20clinic%20background%20bright%20white%20medical%20office%20blue%20accents%20welcoming%20doctor%20portrait%20professional%20lighting&width=600&height=700&seq=mfdentalabout001&orientation=portrait"
                alt="Equipo MF Dental"
                className="w-full h-full object-cover object-top"
              />
              {/* Gradient overlay bottom */}
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0A2540]/60 to-transparent" />
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#0A2540] rounded-2xl p-5 shadow-[0_20px_60px_rgba(10,37,64,0.3)]">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#3A86FF]/20 rounded-xl">
                  <i className="ri-star-fill text-yellow-400 text-2xl" />
                </div>
                <div>
                  <div className="text-white font-bold text-2xl">5.0</div>
                  <div className="text-white/60 text-xs">15 reseñas</div>
                </div>
              </div>
            </div>

            {/* Accent decoration */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#3A86FF]/30 rounded-2xl" />
            <div className="absolute -top-8 -left-8 w-24 h-24 border-2 border-[#3A86FF]/15 rounded-2xl" />
          </div>

          {/* Text side */}
          <div className="scroll-animate-right">
            <h3 className="text-3xl font-bold text-[#0A2540] mb-5 leading-snug">
              Comprometidos con tu salud bucal y tu bienestar
            </h3>
            <p className="text-gray-500 leading-relaxed mb-5">
              En <strong className="text-[#0A2540]">MF Dental</strong> somos un consultorio odontológico
              privado especializado en rehabilitación dental. Nos enfocamos en brindar atención buco-dental
              integral con un trato cálido y personalizado, en un entorno cómodo y profesional.
            </p>
            <p className="text-gray-500 leading-relaxed mb-10">
              Nuestro equipo de especialistas está comprometido con la satisfacción total del paciente,
              utilizando las técnicas más actuales y materiales de la más alta calidad para garantizar
              resultados duraderos y estéticamente superiores.
            </p>

            {/* Values */}
            <div className="space-y-5">
              {values.map((val, i) => (
                <div
                  key={val.title}
                  className={`flex gap-4 items-start scroll-animate anim-delay-${(i + 1) * 100}`}
                >
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#3A86FF]/15 to-[#0A2540]/10 rounded-xl border border-[#3A86FF]/20">
                    <i className={`${val.icon} text-[#3A86FF] text-xl`} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0A2540] mb-1">{val.title}</h4>
                    <p className="text-gray-500 text-sm leading-relaxed">{val.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
